import { idToDate } from '@trello/dates';
import { memberId } from '@trello/session-cookie';

export const isWelcomeBoard = (board: {
  id: string;
  creationMethod?: 'assisted' | 'automatic' | 'demo' | null;
}) => {
  const delta =
    idToDate(board.id).getTime() - idToDate(memberId ?? '').getTime();

  return board.creationMethod === 'demo' || (0 <= delta && delta < 1000);
};
